import React from 'react';
import ReactDOM from 'react-dom/client';

import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

import { LoadingLayout } from '@/components/layout/Loading.layout';

import router from './router';
import store from './store';
import './localization';

import './assets/styles/index.css';
import '@kodkafa/reform/reform.preline.css';
import { Web3ReactProvider } from '@web3-react/core';
import { BrowserProvider, Eip1193Provider } from 'ethers';
// https://docs.cloud.coinbase.com/wallet-sdk/docs/web3-react
// https://codesandbox.io/s/mqlydu?file=/package.json
// https://docs.ethers.org/v6/single-page/
// serve -p 3011 ./dist -s

function getLibrary(provider: Eip1193Provider) {
  const library = new BrowserProvider(provider);
  library.pollingInterval = 8000; // frequency provider is polling
  return library;
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <Provider store={store}>
      <Web3ReactProvider getLibrary={getLibrary}>
        <RouterProvider router={router} fallbackElement={<LoadingLayout />} />
      </Web3ReactProvider>
    </Provider>
  </React.StrictMode>,
);
